<template>
  <div class="container">
    <div class="bsHead">
      <h3>検索結果</h3>
      <PageSelect />
    </div>
    <Books />
    <div class="bsFoot"></div>
  </div>
</template>

<script>
import PageSelect from './PageSelect'
import Books from './Books'

export default {
  components: {
    PageSelect,
    Books,
  },
}
</script>

<style scoped>
.container {
  margin: 0 auto;
  width: 1127px;
}
.bsHead {
  background: url(../../assets/images/book_shelf_head.png) no-repeat;
  height: 132px;
}
.bsFoot {
  background: url(../../assets/images/book_shelf_foot.png) no-repeat;
  height: 104px;
}
</style>
